/**
 * Runtime config — the API address is a DEPLOY variable, not baked into the build.
 *
 * index.html loads `/config` before the bundle; on Cloudflare Pages the Function in
 * functions/config answers it from the project's environment and sets
 * `window.__INFERREX_CONFIG__` (`{ apiBaseUrl, entra }`). The generated Entra provider reads the
 * `entra` half itself; this module reads the API address. The same mechanism frontend/ uses.
 */

export interface InferrexRuntimeConfig {
  readonly apiBaseUrl?: string;
  /** Entra (MSAL) registration for this deployment, read by the generated auth provider. */
  readonly entra?: Readonly<Record<string, string>>;
}

declare global {
  interface Window {
    __INFERREX_CONFIG__?: InferrexRuntimeConfig;
  }
}

/**
 * Where the API is, in order:
 *   1. the runtime config (per deployment),
 *   2. the build-time VITE_API_BASE_URL (local overrides),
 *   3. same origin in a production build (the edge routes /v1 to the API), localhost in dev.
 */
export function apiBaseUrl(
  runtime: InferrexRuntimeConfig | undefined = typeof window !== 'undefined' ? window.__INFERREX_CONFIG__ : undefined,
  env: { readonly VITE_API_BASE_URL?: string | undefined; readonly DEV?: boolean | undefined } = import.meta.env,
): string {
  if (runtime?.apiBaseUrl) return runtime.apiBaseUrl.replace(/\/$/, '');
  if (env.VITE_API_BASE_URL) return env.VITE_API_BASE_URL.replace(/\/$/, '');
  return env.DEV ? 'http://localhost:3000' : '';
}
